"use strict";
/**
 * Dinheiro é sempre inteiro em centavos.
 *
 * Nenhum valor monetário trafega ou é somado como float: 0.1 + 0.2 !== 0.3, e
 * num caixa compartilhado isso vira divergência de saldo.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCents = toCents;
exports.fromCents = fromCents;
exports.formatCurrency = formatCurrency;
exports.formatCurrencyCompact = formatCurrencyCompact;
exports.splitCents = splitCents;
exports.sumCents = sumCents;
const config_1 = require("@nossorachao/config");
/** Converte reais (número ou string "80,00" / "80.00") para centavos. */
function toCents(value) {
    if (typeof value === 'number') {
        if (!Number.isFinite(value))
            throw new RangeError('Valor monetário inválido');
        return Math.round(value * 100);
    }
    const normalized = value
        .trim()
        .replace(/[^\d,.-]/g, '')
        // "1.234,56" (pt-BR) → "1234.56"
        .replace(/\.(?=\d{3}(\D|$))/g, '')
        .replace(',', '.');
    const parsed = Number.parseFloat(normalized);
    if (!Number.isFinite(parsed))
        throw new RangeError(`Valor monetário inválido: ${value}`);
    return Math.round(parsed * 100);
}
/** Converte centavos para reais como número — use apenas para exibição. */
function fromCents(cents) {
    return cents / 100;
}
/** Formata centavos como moeda brasileira: 128000 → "R$ 1.280,00". */
function formatCurrency(cents, withSymbol = true) {
    const formatter = new Intl.NumberFormat(config_1.FINANCE.LOCALE, {
        style: withSymbol ? 'currency' : 'decimal',
        currency: config_1.FINANCE.CURRENCY,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formatter.format(fromCents(cents));
}
/** Formato compacto para dashboards: 128000 → "R$ 1,3 mil". */
function formatCurrencyCompact(cents) {
    const value = fromCents(cents);
    if (Math.abs(value) < 1000)
        return formatCurrency(cents);
    return new Intl.NumberFormat(config_1.FINANCE.LOCALE, {
        style: 'currency',
        currency: config_1.FINANCE.CURRENCY,
        notation: 'compact',
        maximumFractionDigits: 1,
    }).format(value);
}
/**
 * Divide um valor entre N participantes sem perder centavos.
 * O resto é distribuído um centavo por vez, do primeiro ao último.
 */
function splitCents(totalCents, parts) {
    if (parts <= 0)
        throw new RangeError('Número de partes deve ser positivo');
    const base = Math.floor(totalCents / parts);
    const remainder = totalCents - base * parts;
    return Array.from({ length: parts }, (_, index) => base + (index < remainder ? 1 : 0));
}
function sumCents(values) {
    return values.reduce((total, value) => total + value, 0);
}
//# sourceMappingURL=money.js.map